import { PaymentModuleId } from '@foundation/apis/payments';
import Clarity from '@microsoft/clarity';
import { useAuth } from '@shared/auth';
import { useTranslation } from '@shared/localization';
import { JSX } from 'react';

import { RedirectStatus } from '@/components/contexts/params';
import { PayButton } from '@/components/pages/stored-instruments/utils/PayButton';
import { useUserFriendlyPaymentModuleName } from '@/hooks/useUserFriendlyPaymentModuleName';
import { triggerErrorToast } from '@/libs/toasts';
import InvoiceService from '@/services/invoice/InvoiceService';
import Logger, { LoggerOrigin } from '@/services/Logger';
import NavigationService, {
  InternalPage,
} from '@/services/navigation/NavigationService';
import TelemetryService from '@/services/telemetry/TelemetryService';

interface IPayByInvoiceBtnProps {
  navigation?: JSX.Element | null;
}

export function PayByInvoiceBtn({ navigation }: IPayByInvoiceBtnProps) {
  const { accessToken } = useAuth();
  const { t } = useTranslation();
  const paymentModuleT = useUserFriendlyPaymentModuleName();

  return (
    <div className="flex space-x-2">
      {navigation}
      <PayButton
        onClick={() => {
          const currentPage = NavigationService.getInternalPage();
          NavigationService.navigateTo({ page: InternalPage.StatusProcessing });
          InvoiceService.authorise(accessToken ?? '')
            .then(() => {
              NavigationService.navigateTo({
                page: InternalPage.PayByInvoiceStatusSuccess,
              });
              Clarity.setTag('pay', [
                RedirectStatus.Success,
                paymentModuleT(PaymentModuleId.PayByInvoice),
              ]);
            })
            .catch((err) => {
              NavigationService.navigateTo(currentPage);
              TelemetryService.trackException(err, 'PayByInvoiceBtn');
              Logger.error(
                LoggerOrigin.ReactComponent,
                'Payment by Invoice failed',
                err,
              );
              triggerErrorToast(
                t('Something went wrong!'),
                t('Failed to authorize payment by Invoice.'),
              );
              Clarity.setTag('pay', [
                RedirectStatus.Failure,
                paymentModuleT(PaymentModuleId.PayByInvoice),
              ]);
            });
        }}
      />
    </div>
  );
}
